<script>
import {required} from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import {notifyModel} from "@/models/notifyModel";
import {pagingModel} from "@/models/pagingModel";
import {CONSTANTS} from "@/helpers/constants";
import {accountDOfficeModel} from "@/models/accountDOffice";
import Multiselect from "vue-multiselect";
import {apiClient} from "@/state/modules/apiClient";

export default {
  page: {
    title: "Đăng ký tài khoản",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Multiselect},
  data() {
    return {
      title: "Đăng ký tài khoản",
      data: [],
      showModal: false,
      showDetail: false,
      showDeleteModal: false,
      submitted: false,
      action: 1,
      model: accountDOfficeModel.baseJson(),
      pagination: pagingModel.baseJson(),
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      numberOfElement: 1,
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      filter: null,
      isBusy: false,
      sortDesc: false,
      listChucVu: [],
      showModalNoiDungTuChoi: false,
      dataNoiDungTuChoi: null,
      fields: [
        {key: 'STT', label: 'STT', class: 'td-stt', sortable: false},
        {
          key: "userName",
          label: "Tài khoản",
          class: 'td-username',
          sortable: true,
          thClass: 'hidden-sortable',
          thStyle: "min-width: 150px;"
        },
        {
          key: "fullName",
          label: "Họ và tên",
          class: 'td-ten',
          thClass: 'hidden-sortable',
          thStyle: "min-width: 200px;"
        },
        {
          key: "chucVu",
          label: " Chức vụ",
          class: 'td-donVi',
          thClass: 'hidden-sortable',
          thStyle: "min-width: 200px;"
        },
        {
          key: "status",
          label: "Trạng thái",
          class: 'td-donVi',
          thClass: 'hidden-sortable',
          thStyle: "text-align:center; width: 140px"
        },
        {
          key: 'process',
          label: 'Xử lý',
          class: 'td-xuly',
          thClass: 'hidden-sortable',
          thStyle: "min-width: 100px;"
        }
      ],
    };
  },
  validations: {
    model: {
      userName: {
        required,
        customRegex: value => /^[a-zA-Z0-9.]+$/.test(value)
      },
      firstName: {required},
      lastName: {required},
      chucVu: {required}
    },
  },
  created() {
    // this.fnGetList();
    this.getListChucVu();
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
        // addCoQuanToModel()
        // this.saveValueToLocalStorage()
      }
    },
    showModal(status) {
      if (status == false) this.model = accountDOfficeModel.baseJson();
    },
    showDeleteModal(val) {
      if (val == false) {
        this.model.id = null;
      }
    },
  },
  methods: {
    async getListChucVu() {
      await this.$store.dispatch("chucVuStore/getAll").then((res) => {
        this.listChucVu = res.data || [];
      })
    },
    async fnGetList() {
      await this.onPageChange();
    },
    async onPageChange(page = 1) {
      this.pagination.currentPage = page;
      const params = {
        pageNumber: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      }
      this.$refs.tblList?.refresh()
    },
    async handleUpdate(data) {
      this.model = data;
      this.showModal = true;
      this.action = 2
    },
    async handleDetail(id) {
      await this.$store.dispatch("dmLinhVucStore/getById", id).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.model = res.data;
          this.showDetail = true;
        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }
      });
    },
    async handleDelete() {
      if (this.model.id != 0 && this.model.id != null && this.model.id) {
        await apiClient.post("AccountSystem/delete/" + this.model.id).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.fnGetList();
            this.showDeleteModal = false;
            this.$refs.tblList.refresh()
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          // });
        });
      }
    },
    async handleShowNoiDungTuChoi(value) {
      this.dataNoiDungTuChoi = value;
      this.showModalNoiDungTuChoi = true;
    },
    handleShowDeleteModal(id) {
      this.model.id = id;
      this.showDeleteModal = true;
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        await apiClient.put("AccountSystem/create", this.model).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.fnGetList();
            this.showModal = false;
            this.$refs.tblList.refresh()
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
        });
        loader.hide();
      }
      this.submitted = false;
    },
    myProvider(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        content: this.filter,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
        isManager: false
      }
      this.loading = true
      try {
        let promise = apiClient.put("AccountSystem/get-paging-params", params)
        return promise.then(resp => {
          if (resp.resultCode == CONSTANTS.SUCCESS) {
            let data = resp.data;
            this.totalRows = data.totalRows
            let items = data.data
            this.numberOfElement = items.length
            this.loading = false
            return items || []
          } else {
            return [];
          }
        })
      } finally {
        this.loading = false
      }
    },
    clearSearch() {
      this.filter = null;
    }
  }
}
</script>
<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card mb-2">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-12 d-flex align-items-center">
                <h4 class="font-size-18 fw-bold text-dark"> {{ title }} </h4>
              </div>
              <div class="col-md-8 col-12 text-end">
                <b-button
                    variant="primary"
                    type="button"
                    class="btn w-md btn-primary"
                    @click="showModal = true, action = 1"
                    size="sm"
                >
                  <i class="mdi mdi-plus me-1"></i> Đăng ký
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Hiện
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;dòng
                      </label>
                    </div>
                  </div>
                </div>
                <div class="table-responsive-sm">
                  <b-table
                      class="datatables custom-table"
                      :items="myProvider"
                      :fields="fields"
                      striped
                      bordered
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      ref="tblList"
                      primary-key="id"
                      :busy.sync="isBusy"
                      tbody-tr-class="b-table-linhvuc"
                  >
                    <template v-slot:cell(STT)="data">
                      {{ data.index + ((currentPage - 1) * perPage) + 1 }}
                    </template>
                    <template v-slot:cell(chucVu)="data">
                      <div v-if="data.item.chucVu">
                        {{ data.item.chucVu.ten }}
                      </div>
                    </template>
                    <template v-slot:cell(donVi)="data">
                      <div v-if="data.item.donVi">
                        {{ data.item.donVi.ten }}
                      </div>

                    </template>
                    <template v-slot:cell(status)="data">
                      <div style="display: flex; justify-content: center">
                        <button v-if="data.item.status == 0" data-toggle="tooltip" data-placement="bottom"
                                title=" Gửi yêu cầu" type="button" class="btn btn  btn-primary  btn-sm"
                                style="margin-top: 5px;"><i class="fas fa-exchange-alt  me-1"></i>Gửi yêu cầu
                        </button>
                        <button v-else-if="data.item.status == 1" data-toggle="tooltip" data-placement="bottom"
                                title="Đăng ký thành công" type="button" class="btn btn btn-success btn-sm"
                                style="margin-top: 5px;"><i class="fas fa-exchange-alt  me-1"></i> Đăng ký thành công
                        </button>
                        <button v-else @click="handleShowNoiDungTuChoi(data.item)" data-toggle="tooltip"
                                data-placement="bottom" title="Đăng ký thất bại" type="button"
                                class="btn btn btn-danger btn-sm" style="margin-top: 5px;"><i
                            class="fas fa-exchange-alt  me-1"></i> Đăng ký thất bại
                        </button>
                      </div>
                    </template>
                    <template v-slot:cell(process)="data">
                      <button
                          type="button"
                          size="sm"
                          class="btn btn-detail btn-sm"
                          v-on:click="handleUpdate(data.item)">
                        <i class="fas fa-eye"></i>
                      </button>
                      <button
                          type="button"
                          size="sm"
                          class="btn btn-delete btn-sm"
                          v-on:click="handleShowDeleteModal(data.item.id)">
                        <i class="fas fa-trash-alt"></i>
                      </button>
                    </template>
                  </b-table>
                  <template v-if="isBusy">
                    <div align="center">Đang tải dữ liệu</div>
                  </template>
                  <template v-if="totalRows <= 0 && !isBusy">
                    <div align="center">Không có dữ liệu</div>
                  </template>
                </div>
                <div class="row">
                  <b-col>
                    <div>Hiển thị {{ numberOfElement }} trên tổng số {{ totalRows }} dòng</div>
                  </b-col>
                  <div class="col">
                    <div
                        class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
        v-model="showDeleteModal"
        centered
        title="Xóa dữ liệu"
        title-class="font-18"
        no-close-on-backdrop
    >
      <p>
        Dữ liệu xóa sẽ không được phục hồi!
      </p>
      <template #modal-footer>
        <b-button v-b-modal.modal-close_visit
                  size="sm"
                  class="btn btn-outline-info w-md"
                  v-on:click="showDeleteModal = false">
          Đóng
        </b-button>
        <b-button v-b-modal.modal-close_visit
                  size="sm"
                  variant="danger"
                  type="button"
                  class="w-md"
                  v-on:click="handleDelete">
          Xóa
        </b-button>
      </template>
    </b-modal>
    <b-modal
        v-model="showModalNoiDungTuChoi"
        centered
        title="Lý do không duyệt văn bản"
        title-class="fw-bold fs-5 text-dark"
        hide-header
        hide-footer
        no-close-on-backdrop
    >
      <div class="d-flex justify-content-between align-items-center mb-3">
        <p class="fw-bold">Thông tin từ chối</p>
        <b-button pill v-b-modal.modal-close_visit size="sm" class=""
                  v-on:click="showModalNoiDungTuChoi = false">
          <i class="fas fa-times mx-1"></i>
        </b-button>
      </div>
      <div class="row">
        <div class="col-4 text-center">
          <img src="@/assets/images/icon-tu-choi.png" class="w-100" alt="">
        </div>
        <div v-if="dataNoiDungTuChoi" class="col-8">
          <div class="text-black d-flex justify-content-between">
            <p class="fw-medium">Ngày xử lý:</p>
            <p
                class="text-primary px-2"
                style="background-color: rgb(66 153 225 / 10%); border-radius: 3px;"
            >{{ dataNoiDungTuChoi.lastModifiedShow }}</p>
          </div>
          <div class="text-black">
            <p class="fw-medium">Nội dung:</p>
            <p class="" v-if="dataNoiDungTuChoi.message">
              {{ dataNoiDungTuChoi.message }}
            </p>
            <p v-else>
              Không có nội dung
            </p>
          </div>
        </div>
      </div>

      <template #modal-footer>
        <b-button v-b-modal.modal-close_visit size="sm" class="btn btn-outline-info w-md"
                  v-on:click="showModalNoiDungTuChoi = false">
          Đóng
        </b-button>
      </template>
    </b-modal>
    <b-modal
        v-model="showModal"
        title="Thông tin đăng ký"
        title-class="text-black font-18"
        body-class="p-3"
        hide-footer
        centered
        no-close-on-backdrop
        size="lg"
    >
      <form @submit.prevent="handleSubmit"
            ref="formContainer">
        <div class="row">
          <div class="col-6">
            <input type="hidden" v-model="model.id"/>
            <div class="mb-3">
              <label class="text-left">Tên tài khoản</label>
              <span style="color: red">&nbsp;* (D2570290.000290)</span>
              <input
                  id="ten"
                  v-model.trim="model.userName"
                  type="text"
                  class="form-control"
                  placeholder="Nhập mã viên chức"
                  :class="{
                                'is-invalid':
                                  submitted && $v.model.userName.$error,
                              }"
                  :readonly="action == 2"
              />
              <div
                  v-if="submitted && !$v.model.userName.required"
                  class="invalid-feedback"
              >
                Tên tài khoản không được để trống.
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label class="text-left"> Chức vụ</label>
              <span style="color: red">&nbsp;*</span>
              <multiselect v-model="model.chucVu"
                           :options="listChucVu"
                           label="ten"
                           selectLabel="Nhấn vào để chọn"
                           deselectLabel="Nhấn vào để xóa"
                           track-by="id"
                           :class="{
                                'is-invalid':
                                  submitted && $v.model.chucVu.$error,
                              }"
                           placeholder="Chọn vai trò"
                           :disabled="action == 2"
              ></multiselect>
              <div
                  v-if="submitted && !$v.model.chucVu.required"
                  class="invalid-feedback"
              >
                Vai trò không được trống.
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left"> Họ</label>
              <span style="color: red">&nbsp;*</span>
              <input
                  id="ten"
                  v-model.trim="model.lastName"
                  type="text"
                  class="form-control"
                  placeholder="Nhập họ"
                  :class="{
                                'is-invalid':
                                  submitted && $v.model.lastName.$error,
                              }"
                  :readonly="action == 2"
              />
              <div
                  v-if="submitted && !$v.model.lastName.required"
                  class="invalid-feedback"
              >
                Họ và tên đệm không được để trống.
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left"> Tên </label>
              <span style="color: red">&nbsp;*</span>
              <input
                  id="ten"
                  v-model.trim="model.firstName"
                  type="text"
                  class="form-control"
                  placeholder="Nhập tên"
                  :class="{
                                'is-invalid':
                                  submitted && $v.model.firstName.$error,
                              }"
                  :readonly="action == 2"
              />
              <div
                  v-if="submitted && !$v.model.firstName.required"
                  class="invalid-feedback"
              >
                Tên không được để trống.
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="mb-3">
              <label class="text-left"> Ghi chú </label>
              <textarea
                  v-model.trim="model.notes"
                  type="text"
                  class="form-control"
                  placeholder="Nhập ghi chú (nếu có)"
                  :readonly="action == 2"
              > </textarea>
            </div>
          </div>
        </div>
        <div class="text-end pt-2 mt-2">
          <b-button variant="light" class="w-md" size="sm" @click="showModal = false">
            Đóng
          </b-button>
          <b-button v-if="action == 1" type="submit" variant="primary" size="sm" class="ms-1 w-md">
            Đăng ký
          </b-button>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<style>
.td-stt {
  text-align: center;
}

.td-xuly {
  text-align: center;
}

.table > tbody > tr > td {
  padding: 0px;
  line-height: 30px;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}

@media only screen and (max-width: 768px) {
  .b-table-linhvuc > td:nth-of-type(1):before {
    content: "STT";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-linhvuc > td:nth-of-type(2):before {
    content: "Tài khoản";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-linhvuc > td:nth-of-type(3):before {
    content: "Họ và tên";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-linhvuc > td:nth-of-type(4):before {
    content: "Chức vụ";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-linhvuc > td:nth-of-type(5):before {
    content: "Đơn vị";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-linhvuc > td:nth-of-type(6):before {
    content: "";
    font-weight: bold;
    color: #00568c;
  }
}

</style>
